import { render, staticRenderFns } from "./menuFeat.vue?vue&type=template&id=f32c5f3a&scoped=true"
import script from "./menuFeat.vue?vue&type=script&lang=js"
export * from "./menuFeat.vue?vue&type=script&lang=js"
import style0 from "./menuFeat.vue?vue&type=style&index=0&id=f32c5f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32c5f3a",
  null
  
)

export default component.exports